/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Link } from '@carbon/react';

import * as Styled from 'experiments/ai-features/feel-copilot/FeelCopilotDiscovery.styled';
import { feelCopilotDocsLink } from 'experiments/ai-features/feel-copilot/feel-copilot-docs-link';

export const FeelCopilotDiscovery = ({ organizationManagementPageUrl, hasElevatedOrganizationPermissions }) => {
  return (
    <Styled.Container>
      <Styled.Tag type="cool-gray">Alpha feature</Styled.Tag>
      <Styled.Heading>Camunda AI features</Styled.Heading>
      <Styled.Description>
        {hasElevatedOrganizationPermissions ? (
          <>
            Enable{' '}
            <Link href={`${organizationManagementPageUrl}/settings`} aria-label="Organization Settings" target="_blank">
              AI-powered features in Console
            </Link>{' '}
            to get access to
            <Link href={feelCopilotDocsLink} aria-label="FEEL Copilot" target="_blank">
              FEEL Copilot
            </Link>
            .
          </>
        ) : (
          <>
            <>
              Contact your org admin to enable{' '}
              <Link href={feelCopilotDocsLink} aria-label="FEEL Copilot" target="_blank">
                FEEL Copilot
              </Link>
              .
            </>
          </>
        )}
      </Styled.Description>
    </Styled.Container>
  );
};
